/*
 * Prime Bites recipes filter
 * Filters the recipe article grid by namespaced article tags (category: / attribute:).
 *
 * Both groups are single-select: pick one category and/or one attribute.
 * Selections combine with AND (a card must match the selected category AND the
 * selected attribute). "all" in a row clears that row's selection.
 */
(function () {
  function norm(value) {
    return (value || '').toLowerCase().trim();
  }

  function tagList(el, attr) {
    return norm(el.getAttribute(attr))
      .split('|')
      .map(function (tag) {
        return tag.trim();
      })
      .filter(Boolean);
  }

  function init() {
    var filterBar = document.querySelector('[data-pb-component="recipes-filter-bar"]');
    var grid = document.querySelector('[data-pb-section="recipes-article-grid"]');
    if (!filterBar || !grid) {
      return;
    }

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-pb-card]'));
    var noResults = grid.querySelector('[data-pb-no-results]');
    var pills = Array.prototype.slice.call(
      filterBar.querySelectorAll('[data-pb-filter], [data-pb-filter-reset]')
    );
    if (!cards.length || !pills.length) {
      return;
    }

    // One active selection per group (null = "all").
    var selected = {
      category: null,
      attribute: null
    };

    function apply() {
      var visible = 0;
      cards.forEach(function (card) {
        var cats = tagList(card, 'data-pb-categories');
        var attrs = tagList(card, 'data-pb-attributes');

        var okCategory = !selected.category || cats.indexOf(selected.category) !== -1;
        var okAttribute = !selected.attribute || attrs.indexOf(selected.attribute) !== -1;

        var show = okCategory && okAttribute;
        card.hidden = !show;
        if (show) {
          visible += 1;
        }
      });

      if (noResults) {
        noResults.hidden = visible !== 0;
      }
    }

    function syncPills() {
      pills.forEach(function (pill) {
        var active = false;
        if (pill.hasAttribute('data-pb-filter-reset')) {
          var resetGroup = pill.getAttribute('data-pb-filter-reset');
          active = !selected[resetGroup];
        } else {
          var group = pill.getAttribute('data-pb-filter');
          var tag = norm(pill.getAttribute('data-pb-tag'));
          active = selected[group] === tag;
        }
        pill.classList.toggle('pb-recipes-filters__pill--active', active);
        pill.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    pills.forEach(function (pill) {
      if (pill.dataset.pbBound) {
        return;
      }
      pill.dataset.pbBound = '1';

      pill.addEventListener('click', function () {
        if (pill.hasAttribute('data-pb-filter-reset')) {
          selected[pill.getAttribute('data-pb-filter-reset')] = null;
        } else {
          var group = pill.getAttribute('data-pb-filter');
          var tag = norm(pill.getAttribute('data-pb-tag'));
          // Click the active pill again to clear that row.
          selected[group] = selected[group] === tag ? null : tag;
        }
        syncPills();
        apply();
      });
    });

    syncPills();
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
